export default __webpack_public_path__ + "static/media/lp-home-button.807b71c7.jpg";